import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 7AFA8EEF-6A41-4A7D-97D2-F9F03DB24DB0
 * name home-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-variant.svg
 * tags
 * - Home Automation 
 */
export const HomeVariantIcon = createSvgIcon(<><path d="M12,3L20,9V21H15V14H9V21H4V9L12,3Z" /></>, 'HomeVariantIcon');
export default HomeVariantIcon